///<reference path="../require.d.ts"/>

import ITimeoutService = angular.ITimeoutService;
interface News {
    published_on: string;
    title: string;
    body: string;
    image: string;
}

class NewsController {

    static $inject = ["$element", "$timeout", "$http", "$sce"];

    news: News[];

    constructor(
        $element: angular.IAugmentedJQuery,
        $timeout: angular.ITimeoutService,
        $http: angular.IHttpService,
        private $sce: angular.ISCEService
    ) {
        $http.get<News[]>(`${apiRoot}/news`).success((result) => {
            this.news = result;
            if (this.news.length > 0) {
                // レンダリングが終わってから開始する
                $timeout(() => $element.carousel(), 0);
            }
        });
    }

    hasImage(n: News): boolean {
        return !!n.image;
    }

    image(n: News): string {
        if (n.image) {
            return this.$sce.trustAsResourceUrl(n.image);
        } else {
            return null;
        }
    }

    body(n: News): string {
       return this.$sce.trustAsHtml(n.body);
    }

    publishedOn(n: News): string {
        return moment(n.published_on).format("YYYY/M/D");
    }
}

angular.module('hp').controller('NewsController', NewsController);



// WEBPACK FOOTER //
// ./controllers/NewsController.ts